import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../../../../core/services/language.service';
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { ApiVehicleShareService } from '../../../../../core/services/api/Vehicle/api-vehicle-share';
import { ShareVehicleInviteResponse } from '../../../../../core/models/member.model';

@Component({
  selector: 'app-vehicle-share-inbox',
  imports: [CommonModule],
  templateUrl: './vehicle-share-inbox.component.html',
  styleUrl: './vehicle-share-inbox.component.css',
})
export class VehicleShareInboxComponent implements OnInit {
  currentLanguage: 'TH' | 'EN' = 'TH';
  uid = '';
  invites: ShareVehicleInviteResponse[] = [];

  constructor(
    private router: Router,
    private languageService: LanguageService,
    private toastCustomService: ToastCustomService,
    private apiVehicleShareService: ApiVehicleShareService,
    private cookieService: CookieService
  ) {
    this.languageService.currentLang$.subscribe((lang) => {
      this.currentLanguage = lang;
    });
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
  }

  ngOnInit() {
    this.loadInbox();
  }

  goback() {
    this.router.navigate(['/vehicles-option']);
  }

  msg(th: string, en: string) {
    return this.currentLanguage === 'TH' ? th : en;
  }

  showSuccess(text: string) {
    this.toastCustomService.showSuccess('', text);
  }
  showError(text: string) {
    this.toastCustomService.showError('', text);
  }

  loadInbox() {
    this.apiVehicleShareService.getInvitesInbox(this.uid, 'pending').subscribe({
      next: (res) => {
        this.invites = res || [];
      },
      error: () => {
        this.invites = [];
        this.showError(this.msg('โหลดคำเชิญไม่สำเร็จ', 'Failed to load invites'));
      },
    });
  }

  accept(invite: ShareVehicleInviteResponse) {
    this.apiVehicleShareService
      .acceptInvite({ uid: this.uid, inviteId: invite.id })
      .subscribe({
        next: (res) => {
          if (res?.code === '000' || res?.success) {
            this.showSuccess(res.message || this.msg('รับคำเชิญสำเร็จ', 'Accepted'));
            this.loadInbox();
          } else {
            this.showError(
              this.currentLanguage === 'TH'
                ? res?.message || 'ไม่สำเร็จ'
                : res?.message_en || 'Failed'
            );
          }
        },
        error: () => this.showError(this.msg('ไม่สำเร็จ', 'Failed')),
      });
  }

  reject(invite: ShareVehicleInviteResponse) {
    this.apiVehicleShareService
      .rejectInvite({ uid: this.uid, inviteId: invite.id })
      .subscribe({
        next: (res) => {
          if (res?.code === '000' || res?.success) {
            this.showSuccess(res.message || this.msg('ปฏิเสธแล้ว', 'Rejected'));
            this.loadInbox();
          } else {
            this.showError(
              this.currentLanguage === 'TH'
                ? res?.message || 'ไม่สำเร็จ'
                : res?.message_en || 'Failed'
            );
          }
        },
        error: () => this.showError(this.msg('ไม่สำเร็จ', 'Failed')),
      });
  }
}
